@if (visible()) {
  <div class="cookie-banner">
    <p class="cookie-banner__text">
      We use "Strictly Necessary" cookies to keep our site reliable and secure.
      We'd like to set additional cookies to understand site usage, make site
      improvements, and remember your settings.
    </p>
    <div class="cookie-banner__actions">
      <kc-button
        variant="primary"
        size="m"
        text="Accept Cookies and Continue"
        (buttonClick)="accept()"
      />
      <kc-button
        variant="secondary"
        size="m"
        text="Reject Additional Cookies"
        (buttonClick)="reject()"
      />
    </div>
  </div>
}
